module.exports = __webpack_public_path__ + "mop.jpg?64e81d544e1a8229890ea1f9aa5b1d2f";